module.exports = __webpack_public_path__ + "static/img/2020-11-16 16.35.15.8509b71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2020-11-16 16.35.15.jpg
// module id = xnZ2
// module chunks = 4